import * as React from "react"
import Svg, { G, Path, Defs, ClipPath } from "react-native-svg"

function SvgComponent() {
  return (
    <Svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
    >
      <G
        clipPath="url(#clip0_4107_2542)"
        stroke="#434BFF"
        strokeLinejoin="round"
      >
        <Path d="M9 14l6-6" strokeLinecap="square" />
        <Path
          d="M9.5 9a.5.5 0 100-1 .5.5 0 000 1zM14.5 14a.5.5 0 100-1 .5.5 0 000 1z"
          fill="#434BFF"
          strokeLinecap="round"
        />
        <Path
          d="M5 21V5a2 2 0 012-2h10a2 2 0 012 2v16l-3-2-2 2-2-2-2 2-2-2-3 2z"
          strokeLinecap="round"
        />
      </G>
      <Defs>
        <ClipPath id="clip0_4107_2542">
          <Path fill="#434BFF" d="M0 0H24V24H0z" />
        </ClipPath>
      </Defs>
    </Svg>
  )
}

export default SvgComponent
